import Router from 'vue-router'

import Users from '@/components/routes/users/Users.vue'
import ContractCreate from '@/components/routes/contractCreate/ContractCreate'
import AgentContracts from '@/components/routes/agentContracts/AgentContracts'
import Contract from '@/components/routes/contract/Contract'
import Subscription from '@/components/routes/subscription/Subscription'

import settingsRoutes from './settingsRoutes.js'
import unprotectedRoutes from './unprotectedRoutes.js'

import agenciesRoutes from './agenciesRoutes.js'
import agencyRoutes from './agencyRoutes.js'
import agentRoutes from './agentRoutes.js'

import store from '../store/store'
import { ability } from '../permissions/rules'
import { loadLanguageAsync } from '@/locales/i18n-setup'
import moment from 'moment'

import fetchContract from './utils/fetchContract'

const isAuth = () => store.getters['user/isAuth']
const getUser = () => store.getters['user/getUser']
const setPaymentPlans = () => store.dispatch('paymentPlans/setPaymentPlans')

const router = new Router({
  mode: 'history',
  routes: [
    ...unprotectedRoutes,
    ...settingsRoutes,
    ...agenciesRoutes,
    ...agencyRoutes,
    ...agentRoutes,
    {
      name: 'contractCreate',
      path: '/new-contract',
      component: ContractCreate
    },
    {
      name: 'agentContracts',
      path: '/contracts',
      component: AgentContracts
    },
    {
      name: 'contract',
      path: '/contract/:contractId',
      component: Contract,
      beforeEnter: fetchContract,
      props: true
    },
    {
      name: 'subscriptionUpdate',
      path: '/contract/:contractId/subscription',
      component: Subscription,
      beforeEnter: fetchContract,
      props: true
    },
    {
      name: 'users',
      path: '/users',
      component: Users
    }
  ],

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  const authRequired = to.matched.some(record => !record.meta.ignoreAuth)
  if (authRequired && !isAuth()) {
    next({ name: 'login' })
  } else if (!authRequired) {
    next()
  } else {
    // Before auth app routing

    // 1. Check if user can access route depend on role
    const canEnterRoute = to.matched.some(record => ability.can('enterRoute', record.name))

    // 2. Check and set user preferred language
    await loadLanguageAsync(getUser().lang.name)
    moment.locale(getUser().lang.name)

    // 3. Load helper data. Async but not really need to wait for it
    setPaymentPlans()

    if (process.env.NODE_ENV === 'development' && !canEnterRoute) {
      console.error(`User has no access to route [${to.path}]`)
    }

    next(canEnterRoute ? true : { name: 'home' })
  }
})

export default router
